export default {
  UNPROCESSED: 'UNPROCESSED',
  IN_PRINTING: 'IN_PRINTING',
  IN_PRODUCTION: 'IN_PRODUCTION',
  IN_TRANSIT: 'IN_TRANSIT',
  IN_INVENTORY: 'IN_INVENTORY',
  ISSUED_TO_PATIENT: 'ISSUED_TO_PATIENT',
  COMPLETED: 'COMPLETED',
  NOT_TRACKED: 'UNTRACKED',
} as const
